import axios from "./axios";

export default {
    getAccountingEntryDetailTypes(){
        const options = {
            method: 'GET',
            url: '/accountingentrydetailtype',
            headers: {'content-type': 'application/json'},
        }
        return new Promise( ( resolve, reject ) => {
            axios(options)
                .then( response => {

                    if( response === undefined ){
                        reject( 'No se obtuvo respuesta del servidor' );
                    } else if( response.data.success ){
                        resolve( response.data );
                    } else {
                        reject( response.data );
                    }
                } )
                .catch( error => {
                    reject( error );
                } );
        } )
    }
}